import axios from 'axios';

export const GET_NOTIFICATIONS = 'notifications';
export const GET_NOTIFICATIONS_UNREAD = 'unread-notifications';
export const PUT_NOTIFICATIONS_CONSUMED = 'notifications/consumed';
export const GET_COURSE_NOTIFICATIONS = 'v3/cms/course-notifications';
export const GET_ALL_COURSE_NOTIFICATIONS = 'v3/cms/notifications';
export const GET_LESSON_ITEM_NOTIFICATIONS = 'v3/cms/lesson-item-notifications';
export const POST_NOTIFICATIONS_TO_RESOLVE = 'front/cms/notifications-to-resolve';

export function getAllNotifications(params) {
  return axios.get(GET_NOTIFICATIONS, { params });
}

export function getAllNotificationsUnread(params) {
  return axios.get(GET_NOTIFICATIONS_UNREAD, { params });
}

export function readNotificationsByGuids(params) {
  return axios.put(GET_NOTIFICATIONS, params);
}

export function consumedNotificationsByGuids(params) {
  return axios.put(PUT_NOTIFICATIONS_CONSUMED, params);
}

export function getCourseNotifications(courseId) {
  return axios.get(`${GET_COURSE_NOTIFICATIONS}/${courseId}`);
}

export function getAllCourseNotifications() {
  return axios.get(GET_ALL_COURSE_NOTIFICATIONS);
}

export function getLessonItemNotifications(guid) {
  return axios.get(`${GET_LESSON_ITEM_NOTIFICATIONS}/${guid}`);
}

export function getUnresolvedNotifications(courseId, itemId) {
  return axios.get(`${GET_COURSE_NOTIFICATIONS}/${courseId}/item/${itemId}/unresolved`);
}

export function resolveNotifications(body) {
  return axios.post(POST_NOTIFICATIONS_TO_RESOLVE, body);
}
